import { X } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

interface SocialMediaLink {
  name: string;
  icon: string;
  url: string;
}

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose }) => {
  const shareMessage =
    "Hello there, I'm inviting you to EXPOMORE! I've found it really helpful, and I think you'll love it too. It's also a great place to profit from your knowledge and skills! www.EXPOMORE.com";

  const linkedInShareUrl = `${process.env.NEXT_PUBLIC_LINKEDIN_SHARE_URL}?url=www.EXPOMORE.com&summary=`;
  const socialMediaLinks: SocialMediaLink[] = [
    {
      name: 'Message',
      icon: '/message.png',
      url: `sms:?&body=${encodeURIComponent(shareMessage)}`,
    },
    { name: 'WhatsApp', icon: '/whatsapp.svg', url: `https://wa.me/?text=${encodeURIComponent(shareMessage)}` },
    {
      name: 'Facebook',
      icon: '/facebook.svg',
      url: `https://www.facebook.com/sharer/sharer.php?u=www.EXPOMORE.com&quote=${encodeURIComponent(shareMessage)}`,
    },
    {
      name: 'Instagram',
      icon: '/insta.svg',
      url: `https://www.instagram.com/?url=www.EXPOMORE.com&text=${encodeURIComponent(shareMessage)}`,
    },
    {
      name: 'Twitter',
      icon: '/twitter.svg',
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`,
    },
    {
      name: 'LinkedIn',
      icon: '/linkedin.svg',
      url: `${linkedInShareUrl}${encodeURIComponent(shareMessage)}`,
    },
    { name: 'Snapchat', icon: '/snap.svg', url: 'https://snapchat.com/t/ILxbhbeE' },
    { name: 'TikTok', icon: '/tiktok.svg', url: 'http://tiktok.com/@ExpomoreGlobal' },
  ];

  const copyLink = () => {
    navigator.clipboard
      .writeText('www.EXPOMORE.com')
      .then(() => {
        window.alert('Link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy the link: ', err);
      });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className={`relative w-11/12 max-w-lg rounded-lg p-6 bg-white text-black`}>
        <div
          role="button"
          aria-label="Close"
          className="flex items-center justify-center border border-black absolute cursor-pointer bg-white h-6 w-6 rounded-full -top-2 -right-1"
        >
          <X onClick={onClose} className="text-black transition-transform duration-300 ease-in-out hover:rotate-180" />
        </div>

        <p className={`text-center mb-6 font-semibold text-lg text-black`}>
          Share EXPOMORE with your family and friends so they can profit from their knowledge and skills
        </p>

        <div className="grid grid-cols-4 gap-4 mb-6">
          {socialMediaLinks.map((social) => (
            <Link key={social.name} href={social.url} target="_blank" className="flex flex-col items-center">
              <div className="bg-[#2c2c2c] rounded-full p-3 mb-2 hover:bg-[#3c3c3c]">
                <Image src={social.icon} alt={social.name} width={24} height={24} />
              </div>
              <span className="text-xs">{social.name}</span>
            </Link>
          ))}
        </div>

        <div className="flex items-center border border-[#3c3c3c] rounded-md mb-6">
          <input
            type="text"
            value="www.EXPOMORE.com"
            readOnly
            className="flex-grow bg-transparent px-3 py-2 text-sm outline-none"
          />
          <button onClick={copyLink} className="bg-[#4c4c4c] text-white px-4 py-2 rounded-r-md hover:bg-[#5c5c5c]">
            Copy
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
